/* src/app/shop/productos/product-custom-elements/previews/notebook-preview/notebook-preview.component.scss */
#notebook-preview-container {
  width: 100%;
  position: relative;
}
#notebook-preview-container img,
#notebook-preview-container svg {
  position: absolute;
}
#notebook-preview-container #front svg {
  fill: black;
  opacity: 10%;
}
#notebook-preview-container #back svg {
  fill: black;
  opacity: 85%;
}
#notebook-preview-container #inner svg {
  opacity: 0%;
}
#notebook-preview-container #rings svg {
  opacity: 40%;
  fill: white;
}
.cls-1 {
  background-color: blue;
}
/*# sourceMappingURL=notebook-preview.component-VHPW4VYJ.css.map */
